import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { CheckCircle2, Loader2 } from 'lucide-react';
import { fetchCollection } from '../lib/cms';

const About = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadContent = async () => {
      const data = await fetchCollection('about_page');
      if (data && data.length > 0) {
        setContent(data[0]);
      }
      setLoading(false);
    };
    loadContent();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
      </div>
    );
  }

  if (!content) return null;

  const lang = 'da';
  const heroTitle = content.hero_title[lang];
  const mainContent = content.main_content[lang];
  const skills = content.skills[lang].split('\n').filter(s => s.trim() !== '');
  const imageUrl = content.image[0];
  const imageCaption = content.image_caption[lang];

  return (
    <>
      <Helmet>
        <title>Om mig | LimfjordsOdderen</title>
        <meta name="description" content="Lær mere om hvem jeg er, min baggrund i Limfjorden og mine daglige rutiner som odder." />
      </Helmet>

      <div className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-8 text-slate-900">
                {heroTitle}
              </h1>
              <div 
                className="prose prose-lg text-slate-600 max-w-none"
                dangerouslySetInnerHTML={{ __html: mainContent }}
              />

              <div className="mt-10 space-y-4">
                {skills.map((skill) => (
                  <div key={skill} className="flex items-center gap-3">
                    <CheckCircle2 className="h-6 w-6 text-blue-600" />
                    <span className="font-medium text-slate-800">{skill}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <div className="aspect-square rounded-3xl overflow-hidden shadow-2xl rotate-3 hover:rotate-0 transition-transform duration-500">
                <img 
                  src={imageUrl} 
                  alt="Odder der slapper af"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-2xl shadow-xl max-w-xs hidden md:block -rotate-3">
                <p className="italic text-slate-600">
                  {imageCaption}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
